import React from 'react';
import './Transport.css';

const Transport = () => {
  return (
    <div className="Transport-Routes">
      <div className="Route">
        <h2>Routes et transports</h2>
        <p>Nos services couvrent l’électrification, l’automatisation et la maintenance des systèmes de signalisation, d’éclairage et d’infrastructures électriques pour un transport plus sûr et plus intelligent.</p>
      </div>
    </div>
  );
};

export default Transport;